export default __webpack_public_path__ + "static/media/factory.3bc3c42a.svg";